/** WebAudio bilan sintez qilingan ovozlar (demo): chime — to'g'ri javob, boop — xato, pew — o'q. */
let AC: AudioContext | null = null;
const ctx = () => {
  const w = window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext };
  AC = AC || new (w.AudioContext || w.webkitAudioContext!)();
  if (AC.state === 'suspended') void AC.resume();
  return AC;
};

function tone(f: number, st: number, dur: number, amp: number, type: OscillatorType, dest: AudioNode, att = 0.005) {
  const a = ctx(); const o = a.createOscillator(), g = a.createGain(); o.type = type; o.frequency.value = f;
  g.gain.setValueAtTime(0.0001, st); g.gain.exponentialRampToValueAtTime(amp, st + att); g.gain.exponentialRampToValueAtTime(0.0001, st + dur);
  o.connect(g); g.connect(dest); o.start(st); o.stop(st + dur + 0.05);
}
function reverb(sec: number) {
  const a = ctx(); const len = Math.floor(a.sampleRate * sec), buf = a.createBuffer(2, len, a.sampleRate);
  for (let c = 0; c < 2; c++) { const d = buf.getChannelData(c); for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.6) * 0.6; }
  const cv = a.createConvolver(); cv.buffer = buf; return cv;
}

export function chime() {
  try {
    const a = ctx(); const t0 = a.currentTime + 0.01, out = a.createGain(); out.gain.value = 0.3;
    const lp = a.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 4200; lp.connect(out); out.connect(a.destination);
    const rv = reverb(0.9), wet = a.createGain(); wet.gain.value = 0.32; rv.connect(wet); wet.connect(out);
    const bus = a.createGain(); bus.gain.value = 1; bus.connect(lp); bus.connect(rv);
    ([[880, 0, 0.85], [1174.66, 0.115, 1]] as const).forEach(([f, dt, v]) => {
      const st = t0 + dt;
      tone(f, st, 0.95, 0.62 * v, 'sine', bus, 0.008);
      tone(f * 1.0023, st, 0.8, 0.22 * v, 'sine', bus, 0.008);
      tone(f * 2, st, 0.32, 0.10 * v, 'sine', bus, 0.006);
      tone(f * 3.98, st, 0.07, 0.07 * v, 'sine', bus, 0.003);
    });
  } catch { /* ignore */ }
}
export function boop() {
  try { const a = ctx(); const t0 = a.currentTime + 0.01, g = a.createGain(); g.gain.value = 0.25; g.connect(a.destination); tone(196, t0, 0.18, 0.6, 'sine', g, 0.005); tone(147, t0 + 0.06, 0.2, 0.5, 'sine', g, 0.005); } catch { /* ignore */ }
}
export function pew() {
  try {
    const a = ctx(); const t0 = a.currentTime + 0.005, o = a.createOscillator(), g = a.createGain(); o.type = 'triangle';
    o.frequency.setValueAtTime(1400, t0); o.frequency.exponentialRampToValueAtTime(320, t0 + 0.16);
    g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(0.12, t0 + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.18);
    o.connect(g); g.connect(a.destination); o.start(t0); o.stop(t0 + 0.2);
  } catch { /* ignore */ }
}
/** «Bilaman»: yumshoq ko'tariluvchi "pop-ding" (belgini olganda — pastroq bitta nota). */
export function knowSound(on: boolean) {
  try {
    const a = ctx(); const t0 = a.currentTime + 0.01, out = a.createGain(); out.gain.value = 0.22; out.connect(a.destination);
    const rv = reverb(0.6), wet = a.createGain(); wet.gain.value = 0.25; rv.connect(wet); wet.connect(out);
    const bus = a.createGain(); bus.connect(out); bus.connect(rv);
    if (on) { tone(659.25, t0, 0.18, 0.5, 'sine', bus, 0.004); tone(987.77, t0 + 0.07, 0.32, 0.45, 'sine', bus, 0.004); tone(1975.5, t0 + 0.07, 0.12, 0.06, 'sine', bus, 0.002); }
    else tone(523.25, t0, 0.2, 0.35, 'sine', bus, 0.004);
  } catch { /* ignore */ }
}
